import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { URole } from '../modelinterfaces/urole.model';
import { EnvironmentHelper } from './environment-helper';

@Injectable({
  providedIn: 'root'
})

export class UserRoleService {

  constructor(private http: HttpClient, private environmentHelper: EnvironmentHelper) {
  }

  public getList(): Observable<URole[]> {
    const url = `${this.environmentHelper.urlV2}/userRole`;
    return this.http.get<URole[]>(url).pipe(
      map(list => URole.valuesOf(list))
    );
  }
}
